
import { of as observableOf, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { HisBackendService, GenericValue } from 'hisng';

import { Journal } from '../model/journal';

@Injectable()
export class JournalService {

    private showBackButton = false;

    constructor( private backendService: HisBackendService ) { }

    setBackButton( calledByForm: boolean ) {
        this.showBackButton = calledByForm;
    }

    getBackButton(): Observable<boolean> {
        return observableOf( this.showBackButton );
    }

    getJournalById( id: number ): Observable<Journal> {
        return this.backendService.getData( `api/v1/fs/res/journal/${id}` );
    }

    saveJournal( journal: Journal ): Observable<Journal> {
        let savedJournal: Observable<Journal>;
        if ( journal.id ) {
            savedJournal = this.backendService.putData( `api/v1/fs/res/journal/${journal.id}`, journal );
        } else {
            savedJournal = this.backendService.postData( 'api/v1/fs/res/journal', journal );
        }
        return savedJournal;
    }

    canDeleteJournal( journalId: number ): Observable<string> {
        return this.backendService.getData( `api/v1/fs/res/journal/canDelete/${journalId}` );
    }

    deleteJournal( journalId: number ): Observable<number> {
        return this.backendService.delete( `api/v1/fs/res/journal/${journalId}` );
    }

    getJournals( searchText: string ): Observable<Journal[]> {
        return this.backendService.getData( `api/v1/fs/res/journal?q=${encodeURI(searchText)}` );
    }

    getStatus(): Observable<GenericValue[]> {
        return this.backendService.getData( 'api/v1/fs/res/state/publication' );
    }

    checkDuplicatesOnCreate( attributesMap: Record<string, string[]> ): Observable<Journal[]> {
        let request = { entityConfigUniquename: 'new-journal', entityAttributes: attributesMap };
        console.log( 'checkDuplicatesOnCreate: request =', JSON.stringify(request) );
        // #287505 Durch { blockUi: false } schalten wir den Klickvorhang ab, der sonst auf der Bearbeiten-Seite kurz aufflackert
        return this.backendService.postData( 'api/v1/fs/res/journal/searchDuplicates/onCreate', request, { blockUI: false } );
    }
}
